/**
 *功能: 客户bs系统
 */
export default {
  $getway: 'OurwayBusiness',
  checkRefPhone: 'mainOrder/checkRefPhone',//风险等级短信验证
  // 查询统计接口
  mainOrderList: 'mainOrder/list', // 台帐
  getBargain: 'mainOrder/getBargain', // 合同号弹出选择
  getRefGoods: 'mainOrder/getRefGoods', // 产品弹出选择
  getTank: 'mainOrder/getTank', // 罐号弹出选择
  getTGuest: 'mainOrder/getTGuest', // 提货人弹出选择
  getCreator: 'mainOrder/getCreator', // 获取制表人
  listAccountBooks: 'mainOrder/listAccountBooks', // 库存账页查询
  listCarList: 'mainOrder/listCarList', // 车辆排队情况查询
  listGoodsAndTank: 'mainOrder/listGoodsAndTank', // 当前库存查询
  listInOutCar: 'mainOrder/listInOutCar', // 汽车计量日报表查询
  getVGuest: 'mainOrder/getVGuest',
  getDateTimeType: 'mainOrder/getDateTimeType', // 日期类别
  getStateList: 'mainOrder/getStateList', // 获取单据状态
  // 汽车收发货详情接口
  detail: 'mainOrder/detail', // 获取收发货详情
  getBlno: 'mainOrder/getBlno', // 提单号下拉
  getBatchNo: 'mainOrder/getBatchNo', // 批号列表
  getOutCarRefTGuest: 'mainOrder/getOutCarRefTGuest', // （装车）获取提货人
  getInCarTank: 'mainOrder/getInCarTank', // 卸车）罐号弹出选择
  getOutCarTank: 'mainOrder/getOutCarTank', // （装车）罐号弹出选择
  getInCarRefGoods: 'mainOrder/getInCarRefGoods', // （卸车）获取产品
  getOutCarRefGoods: 'mainOrder/getOutCarRefGoods', // （装车）获取产品
  getRefVGuest: 'mainOrder/getRefVGuest', // 客户弹出选择
  mainOrderGetBargainId: 'mainOrder/getBargainId', // 合同弹出选择--其他
  getBargainIdCar:'mainOrder/getBargainIdCar',//合同弹出选择-装车
  getServiceId: 'mainOrder/getServiceId', // 取装卸车服务编号
  getInCarBatchId: 'mainOrder/getInCarBatchId', // (卸车)批号列表
  getOutCarBatchId: 'mainOrder/getOutCarBatchId', // (装车)批号列表
  getAttachBargain: 'mainOrder/getOutCarAttachBargain', // 获取附加合同
  getListExcelCarOrderList: 'mainOrder/listExcelCarOrderList', // 上传excel生成数据（车号细表）
  listCarOrderBatch: 'mainOrder/listCarOrderBatch', // 批号系表详情
  listCarOrderList: 'mainOrder/listCarOrderList', // 车号系表详情
  orderValidateBeforeSave:'mainOrder/orderValidateBeforeSave', //保存前校验
  // 汽车保存接口
  save: 'mainOrder/save', // 主细表批量保存
  saveCarOrderBatchList: 'mainOrder/saveCarOrderBatchList', // 批号批量接口
  saveCarOrderListList: 'mainOrder/saveCarOrderListList', // 车号批量保存
  getRefTGuest: 'mainOrder/getRefTGuest', // 获取提货人(详情)

  //查询
  getOrderTypeForWeb:'OrderStandingBook/DBBox_OrderTypeForWeb',//取订单类别
  getServiceIdWeb:'OrderStandingBook/DBBox_ServiceForWeb',//取服务编号
  getMainList:'OrderStandingBook/list',//台账，分页查询
  //装船卸船接口
  getGet_SystemConfig:'ShipOrderLoading/Get_SystemConfig',
  getShips: 'ShipOrderLoading/Get_Ship', // 船名弹出选择
  getBargainShips: 'ShipOrderLoading/Get_BargainShip', // 船名弹出选择
  getBerth: 'ShipOrderLoading/DBBox_Berth', // 泊位下拉
  getBusinessDept: 'ShipOrderLoading/DBBox_Base_BusinessDept', // 泊位下拉
  getShipSupplier:'ShipOrderLoading/Get_FSupplierByTypeShip',//船代弹出选择
  getGoodsSupplier: 'ShipOrderLoading/Get_FSupplierByTypeGoods',//货代弹出选择
  getBargainGoods:'ShipOrderLoading/Get_BargainGoods' ,//产品弹出
  getBargainShipGoods:'ShipOrderLoading/Get_BargainShipGoods' ,//产品弹出
  getHaveGoodGuest:'ShipOrderLoading/Get_HaveGoodGuest',//提货人资料弹出
  getOnShipTank:'ShipOrderLoading/pShipBatchNoForMainOrder',//装船罐号资料弹出
  getOutShipTank:'ShipOrderUnloading/Get_BargainTank',//卸船罐号资料弹出
  save1:'shipOrderListController/saveAll', //船保存方法
  isShipBlack:'ShipOrderLoading/Service_Black_ShipList',//判断是否属于船舶黑名单
  isBLNORepeat:'ShipOrderLoading/Service_Repeat_BLNO',//判断提货人是否存在相同的批号
  isBLEndDateToBargain:'ShipOrderLoading/Check_BLEndDateToBargain',//检查订单结束日期是否大于合同结束日期,
  getShipOrderList:'ShipOrderLoading/Service_Select_ShipOrderList',//,
  getOutShipBath:'ShipOrderUnloading/pShipBatchNoForMainOrder',//批号信息数据,
  getSafeCapacity:'ShipOrderUnloading/Public_IsSafeCapacity',//判断安全罐容
  getBargainDelay:'ShipOrderUnloading/Service_Bargain_Delay',//判断合同是否处于延期
  getTankTax:'ShipOrderUnloading/Service_Get_TankTax',//获取罐是否保税
  checkIsTankOtherGoods:'ShipOrderUnloading/Public_IsTankOtherGoods',//判断是否一个罐里还存在别的产品
  detailShip:'ShipOrderLoading/detail',//详情

  //管线出入接口
  save2:'pipeOrderListController/saveAll',//管线保存
  getPailOrderBatch:'PipeOut/Get_PailOrderBatch',//罐号资料弹出
  getPipeOrderList:'PipeIn/Service_Select_PipeOrderList',//批号信息数据
  detailPipe:'PipeIn/detail',//详情

  //转罐
  getServiceBargainGoods:'TransferOrder/Get_Service_BargainGoods',//产品弹出选择
  getTankGoodsByGuestAndBargainID:'TransferOrder/Get_TankGoodsByGuestAndBargainID',//转出罐号资料弹出
  getTransferOrderIn:'TransferOrder/Service_Select_TransferOrderIn',//转入批号信息数据
  getTransferOrderOut:'TransferOrder/Service_Select_TransferOrderOut',//转出批号信息数据
  saveTransferIn:'transferOrderInController/saveAll',//转入罐保存接口
  saveTransferOut:'transferOrderOutController/saveAll',//转出罐保存接口
  detailTransfer:'TransferOrder/detail',//详情

  //其他
  getOrderDBBox_FieldValues:'OtherOrder/DBBox_FieldValues',//取FieldValues配置信息，订单类别下拉选择用
  saveOther:'OtherOrder/saveAll',//保存其他订单
  detailOther:'ShipOrderLoading/Service_Select_MainOrder',//详情
};
